import React from 'react';
import { CreativeEmptyState } from './CreativeEmptyState';
import NoInsightsIcon from '../../../../resources/icons/creatives/noinsights.svg';

export const CreativeInsightsEmptyState = () => (
    <CreativeEmptyState
        title="STATIC.PAGES.CREATIVE_INSIGHTS.EMPTY_STATE.TITLE"
        stepsCount={2}
        stepsPrefix="STATIC.PAGES.CREATIVE_INSIGHTS.EMPTY_STATE.STEPS"
        icon={<NoInsightsIcon />}
    />
);
